import {Toggletip} from '@dropbox/dig-components/tooltips';
import {Box} from '@dropbox/dig-foundations';
import type {ComponentProps} from 'react';

// A Toggletip's info button beside a label in a flex row. The app's global
// `.dig-ClickOutside {width: 100%}` (dig-overrides/forms.css) would otherwise
// stretch its wrapper and squeeze the label onto two lines; this box keeps it
// to the button's width.
export const InlineToggletip = (props: ComponentProps<typeof Toggletip>) => (
  <Box display="flex" style={{flexShrink: 0}}>
    <Toggletip {...props} />
  </Box>
);
